<template>
    <v-dialog v-model="dialog" max-width="600">
        <template #activator="{ on, attrs }">
            <a v-bind="attrs" v-on="on" :class="btnClass" @click="open">
                <template v-if="btnText">{{btnText}}</template>
                <template v-else>Contact us</template>
            </a>
        </template>

        <v-card class="pa-4">
            <v-card-title class="px-0">
                Contact us
                <v-spacer />
                <v-btn icon><v-icon @click="dialog = false">mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-form v-model="valid" @submit.prevent="submit" ref="form">
                <div class="field-name">Full name *</div>
                <v-text-field outlined dense type="email" v-model="form.Name" :rules="[$validators.notEmpty]"/>

                <div class="field-name">Work email *</div>
                <v-text-field outlined dense type="email" v-model="form.Email" :rules="[$validators.isEmail]"/>

                <div class="field-name">Company name *</div>
                <v-text-field outlined dense type="email" v-model="form.Company" :rules="[$validators.notEmpty]"/>

                <div class="field-name">Job title *</div>
                <v-text-field outlined dense type="email" v-model="form.JobTitle" :rules="[$validators.notEmpty]"/>

                <div class="field-name">Ask us anything, or share your feedback</div>
                <v-textarea outlined dense type="email" v-model="form.Message" :rules="[$validators.notEmpty]"/>

                <v-alert v-if="error" color="red" outlined text>
                    {{error}}
                </v-alert>
                <v-alert v-if="message" color="green" outlined text>
                    {{message}}
                </v-alert>

                <p>
                    By submitting this form, you agree to the
                    <router-link :to="{name: 'privacy'}" target="_blank">Privacy Policy</router-link>
                </p>

                <v-btn block type="submit" :disabled="!valid" :loading="loading" class="blue-btn mt-5">Send</v-btn>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        btnClass: String,
        btnText: String,
    },

    data() {
        return {
            dialog: false,
            form: {
                Name: '',
                Email: '',
                Company: '',
                JobTitle: '',
                Message: '',
            },
            valid: false,
            message: '',
            error: '',
            loading: false,
        };
    },

    methods: {
        open() {
            this.$st.send('contact-us-open', null);
        },
        submit() {
            this.$st.send('contact-us-send', this.form);
            this.loading = true;
            this.error = '';
            this.message = '';
            this.$api.contactUs(this.form, (data, meta) => {
                this.loading = false;
                if (meta.error) {
                    this.error = meta.error;
                    return;
                }
                this.message = "Thanks! We'll get back to you soon.";
            });
        },
    },
}
</script>

<style scoped>

</style>
